import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Api from "../Api";
import dayjs from "dayjs";
import Logo from "../assets/logo.png";
function HomePage() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [showRiwayatModal, setShowRiwayatModal] = useState(false);
  const [data, setData] = useState()
  const [riwayat, setRiwayat] = useState([])
  const [riwayatError, setRiwayatError] = useState("")

  const kodeAset = decodeURIComponent(id || "").trim()

  const getData = async () => {
    if (!kodeAset) {
      setData(null)
      setLoading(false)
      return
    }

    try {
      const res = await Api.get(`/inventori/${encodeURIComponent(kodeAset)}`)
      setData(res.data?.data || null)
    } catch (error) {
      setData(null)
    } finally {
      setLoading(false)
    }
  }

  const getRiwayat = async (kode) => {
    try {
      setRiwayatError("")
      const res = await Api.get(`/perbaikan/${encodeURIComponent(kode)}`)
      setRiwayat(res.data.data || [])
      setShowRiwayatModal(true)
    } catch (error) {
      setRiwayat([])
      setRiwayatError(error.response?.data?.message || "Gagal memuat riwayat aset.")
      setShowRiwayatModal(true)
    }
  }

  const formatTanggal = (value) => {
    if (!value) return "-"
    const parsed = dayjs(value)
    return parsed.isValid() ? parsed.format("DD MMMM YYYY") : "-"
  }

  const sumberColor = (sumber) => {
    switch (sumber) {
      case "Monitoring":
        return "bg-sky-100 text-sky-800"
      case "Perawatan AC":
        return "bg-cyan-100 text-cyan-800"
      case "Perawatan IT":
        return "bg-indigo-100 text-indigo-800"
      default:
        return "bg-emerald-100 text-emerald-800"
    }
  }







  const getStatusColor = (status) => {
    switch (String(status || "").toLowerCase()) {
      case "selesai":
      case "normal":
      case "baik":
        return "bg-green-100 text-green-800";
      case "dalam proses":
      case "dalam pengerjaan":
      case "dicek":
        return "bg-yellow-100 text-yellow-800";
      case "menunggu":
      case "menunggu sparepart":
        return "bg-blue-100 text-blue-800";
      case "dibatalkan":
      case "bermasalah":
      case "rusak":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };



  useEffect(() => {
    getData()
  }, [id])

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-4 border-red-600 mb-4"></div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded animate-pulse w-32 mx-auto"></div>
            <div className="h-3 bg-gray-200 rounded animate-pulse w-24 mx-auto"></div>
          </div>
          <p className="text-gray-600 mt-4 font-medium">Memuat data inventaris...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Content */}
      <div className="px-4 py-6">
        {/* Single Card */}
        {data && (
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 max-w-md mx-auto">
            <div className="p-6">
              {/* Header Card */}
              <div className="text-center mb-6">
                <img src={Logo} alt="Logo" className="w-[150px] h-10 mx-auto" />
                <h2 className="font-bold text-gray-900 text-2xl mb-2">
                  {data.merk}
                </h2>
                <p className="text-indigo-600 font-semibold text-lg">
                  {data.kode}
                </p>
                <p className="text-red-800 font-semibold text-lg">
                  {data.kode_ypt}
                </p>
                {/* <span className={`inline-block px-4 py-2 rounded-full text-sm font-semibold mt-3 ${getKondisiColor(inventaris.kondisi)}`}>
                  {inventaris.kondisi}
                </span> */}
              </div>

              {/* Description */}
              <div className="mb-6">
                <h3 className="text-sm font-semibold text-gray-500 mb-2 uppercase tracking-wide">Deskripsi</h3>
                <p className="text-gray-700 leading-relaxed">
                  {data.desc}
                </p>
              </div>

              {/* Details */}
              <div className="space-y-4 mb-3">
                <div className="flex justify-between items-center py-1 border-b border-gray-100">
                  <span className="text-gray-500 font-normal text-sm">No. SIMKUG</span>
                  <span className=" text-gray-500 text-sm">{data.kode_sim}</span>
                </div>
                <div className="flex justify-between items-center py-1 border-b border-gray-100">
                  <span className="text-gray-500 font-normal text-sm">S/N</span>
                  <span className=" text-gray-500 text-sm">{data.noseri}</span>
                </div>
                <div className="flex justify-between items-center py-1 border-b border-gray-100">
                  <span className="text-gray-500 font-normal text-sm">Spesifikasi</span>
                  <span className="text-gray-500 text-sm">{data.spec}</span>
                </div>
                <div className="flex justify-between items-center py-1 border-b border-gray-100">
                  <span className="text-gray-500 font-normal text-sm">TP</span>
                  <span className="text-gray-500 text-sm">
                    {dayjs(data.tgl).format('YYYY')}
                  </span>
                </div>
                <div className="flex justify-between items-center py-1">
                  <span className="text-gray-500 font-normal text-sm">Lokasi</span>
                  <span className="text-gray-500 text-sm">{data.gedung}/{data.ruang}</span>
                </div>
                <div className="flex justify-between items-center py-1">
                  <span className="text-gray-500 font-normal text-sm">Sumber Dana</span>
                  <span className=" text-gray-500 text-sm">{data.sumber}</span>
                </div>
                <div className="flex justify-between items-center py-1">
                  <span className="text-gray-500 font-normal text-sm">PJ</span>
                  <span className=" text-gray-500 text-sm">{data.pj}</span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="space-y-3">

                <button
                  onClick={() => getRiwayat(data.kode)}
                  className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-4 rounded-xl transition-colors duration-200 flex items-center justify-center space-x-2"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span>Riwayat Aset</span>
                </button>

              </div>
            </div>
          </div>
        )}

        {/* Empty State (jika tidak ada data) */}
        {!data && !loading && (
          <div className="text-center py-12 max-w-md mx-auto">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-4xl">📦</span>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Tidak ada data inventaris
            </h3>
            <p className="text-gray-500 mb-6">
              Data inventaris dengan kode {kodeAset || "-"} tidak ditemukan
            </p>
            <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-200">
              Kembali
            </button>
          </div>
        )}
      </div>

      {/* Modal Riwayat Perbaikan */}
      {showRiwayatModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-hidden">
            {/* Header Modal */}
            <div className="bg-gradient-to-r from-red-500 to-red-600 px-6 py-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white">Riwayat Aset</h3>
                    <p className="text-emerald-100 text-sm">{data?.kode}</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowRiwayatModal(false)}
                  className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center hover:bg-opacity-30 transition-colors"
                >
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Content Modal */}
            <div className="p-6 max-h-[70vh] overflow-y-auto">
              {riwayatError && (
                <div className="bg-red-50 text-red-700 text-sm rounded-xl px-4 py-3 mb-4">
                  {riwayatError}
                </div>
              )}
              {riwayat.length > 0 ? (
                <div className="space-y-4">
                  {riwayat.map((item, index) => (
                    <div key={item.uid || index} className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                      <div className="flex items-start justify-between mb-3 gap-2">
                        <div className="flex items-center space-x-3 min-w-0">
                          <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center shrink-0">
                            <span className="text-emerald-600 font-bold text-sm">#{index + 1}</span>
                          </div>
                          <div className="min-w-0">
                            <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-semibold mb-1 ${sumberColor(item.sumber)}`}>
                              {item.sumber}
                            </span>
                            <h4 className="font-semibold text-gray-900 text-sm">{item.judul}</h4>
                            <p className="text-gray-500 text-xs">
                              {formatTanggal(item.tanggal)}
                            </p>
                          </div>
                        </div>
                        <span className={`px-2 py-1 rounded-full text-xs font-semibold shrink-0 ${getStatusColor(item.status)}`}>
                          {item.status}
                        </span>
                      </div>

                      <div className="grid grid-cols-2 gap-3 mb-3">
                        <div>
                          <p className="text-xs text-gray-500 font-medium">PIC</p>
                          <p className="text-xs text-gray-900">{item.pic || "-"}</p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500 font-medium">Tindakan</p>
                          <p className="text-xs text-emerald-600">{item.tindakan || "-"}</p>
                        </div>
                        {item.tanggal_selesai && (
                          <div>
                            <p className="text-xs text-gray-500 font-medium">Tanggal Selesai</p>
                            <p className="text-xs text-emerald-600">{formatTanggal(item.tanggal_selesai)}</p>
                          </div>
                        )}
                      </div>

                      {item.catatan && (
                        <div className="bg-white rounded-lg p-3 border border-gray-200">
                          <p className="text-xs text-gray-500 font-medium mb-1">Catatan</p>
                          <p className="text-sm text-gray-700 italic">"{item.catatan}"</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8">
                  <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">Belum Ada Riwayat</h4>
                  <p className="text-gray-500 text-sm">Belum ada monitoring, perawatan, atau perbaikan untuk aset ini</p>
                </div>
              )}
            </div>

            {/* Footer Modal */}
            <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
              <div className="flex space-x-3">
                <button
                  onClick={() => setShowRiwayatModal(false)}
                  className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-2.5 px-4 rounded-xl transition-colors duration-200"
                >
                  Tutup
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default HomePage;